// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const ModelContainer = styled.div`
  width: 100%;
  display: flex;
  border: 1px solid ${({ theme }) => theme.colors.modelDetailsBorder};
  justify-content: start;
  border-radius: ${({ theme }) => theme.borders.radius10};
  ${({ theme }) => `
    padding: ${theme.spacing.spacing60};
    background: ${theme.colors.modelDetailsBg};
  `};
  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: ${({ theme }) => theme.spacing.spacing80};
    margin-top: ${({ theme }) => theme.spacing.spacing120};
  }
`;

export const DetailSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.labelMedium};
  text-transform: uppercase;
  ${({ theme }) => `
      color: ${theme.colors.textPrimary};
      margin-bottom: ${theme.spacing.spacing10};
  `};

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.titleXSmall};
    margin-bottom: ${({ theme }) => theme.spacing.spacing10};
  }
`;

export const DescriptionSection = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Description = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.textPrimary};
  white-space: initial;
  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyMedium};
  }
`;

export const ViewModelImages = styled.div`
  ${({ theme }) => `
  color: ${theme.colors.secondary};
  margin-top: ${theme.spacing.spacing50};
  `};
  ${({ theme }) => theme.typography.buttonMedium};
`;

export const ImageSection = styled.div`
  margin-right: ${({ theme }) => theme.spacing.spacing80};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  height: fit-content;
  max-height: 50px;
  position: relative;
  flex-direction: column;
`;

export const ImageBackdrop = styled.div<{ isSecond: boolean; }>`
  ${({ isSecond, theme }) =>
    isSecond
      ? `
      width: 32px;
      background: ${theme.colors.modelDetailsSecondCardBg};
  `
      : `
    width: 36px;
    background: ${theme.colors.modelDetailsCardBg};
  `};
  height: 5px;
  ${({ theme }) => `
    border-radius: 0 0 ${theme.borders.radius10} ${theme.borders.radius10};
  `};
`;

export const ImageContainer = styled.div`
  height: 40px;
  width: 40px;
  border-radius: ${({ theme }) => theme.borders.radius10};
  ${({ theme }) => `outline: 1px solid ${theme.colors.textDecorative};`};
  outline-offset: -1px;
  overflow: hidden;
`;
